import { Component } from '@angular/core';


@Component({
  selector: 'app-dashboard-page-footer',
  templateUrl: './dashboard-page-footer.component.html',
  styleUrls: ['./dashboard-page-footer.component.scss']
})
export class DashboardPageFooterComponent {
  year = new Date().getFullYear();
  constructor() { }
}
